export const API_PROFILE_V1_GROUPS = 'api/admin/v1/groups';
export const API_PROFILE_V1_NEWS = 'api/news';
export const API_PROFILE_V1_OBSERVABLES_PREVIEW =
  '/api/admin/v1/observables/previews';
export const API_PROFILE_V1_PATIENTS = '/api/admin/v1/patients';
export const API_PROFILE_V1_PATIENTS_EXCEL = 'api/admin/v1/patients/excel';
export const API_SHARE_V1_OBSERVERS_FILTER_EMAILPART =
  'api/share/v1/observers/filter';
export const API_AUTH_V1_REFRESH = '/api/v1/auth/refresh';
export const API_AUTH_V1_LOGIN = '/api/v1/auth/login';
export const API_V1_ADMIN_ACCOUNTS = '/api/v1/admin/account';
export const API_V1_ADMIN_ACCOUNTS_ROLES = '/api/v1/system-user/roles';
export const API_DIARY_V1_TAGS = '/api/diary/v1/tags';
export const API_V1_ADMIN_MEASUREMENT = '/api/v1/admin/measurement';
export const API_V1_ADMIN_MEASUREMENT_EXCEL = 'api/admin/v1/events/excel';
export const API_V1_ADMIN_MEASUREMENT_TYPES = '/api/v1/measurement/types';
export const API_PROFILE_V1_METRICS_EVENT_MEASURERS =
  '/api/admin/v1/metrics/event-measurers';
export const API_PROFILE_V1_METRICS_EVENT_MEASURERS_EXCEL =
  '/api/admin/v1/metrics/event-measurers/excel';
export const API_PROFILE_V1_DIABET_TYPES = '/api/profile/v1/diabet/types';
export const API_ADMIN_MAP_POINTS = 'api/salepoints/v1/points';

export const API_ADMIN_DFU_MODES = '/api/admin/glucometer-dfu-modes';

export const API_ADMIN_APP_VERSION = '/api/v1/admin/app-version';
export const API_ADMIN_PUSH_NOTIFICATIONS = '/api/v1/admin/push-notifications';
